import { notify } from 'reapop'
import { FeedbackConstants } from '../constants'
import { FeedbackService } from '../services'


export const FeedbackLogAction = {
    getFeedbackData
}

function getFeedbackData(data) {
    return dispatch => {
        dispatch(request())

        FeedbackService.getFeedback(data)
            .then(
                verified => dispatch(success(verified)),
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(notify({ position: "tc", dismissible: false, message: error.toString(), status: "error" }))
                }
            )
    }

    function request() { return { type: FeedbackConstants.GET_FEEDBACK_REQUEST } }
    function success(result) { return { type: FeedbackConstants.GET_FEEDBACK_SUCCESS, result } }
    function failure(error) { return { type: FeedbackConstants.GET_FEEDBACK_FAILURE, error } }
}
